import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { apiCall } from "./rechnungen/rUtils";
import { InvoiceList } from "./rechnungen/InvoiceList";
import { MonthOverview } from "./rechnungen/MonthOverview";
import { UninvoicedPanel } from "./rechnungen/UninvoicedPanel";
import { ExportPanel } from "./rechnungen/ExportPanel";
import { InvoiceSettings } from "./rechnungen/InvoiceSettings";
import { InvoiceDialog } from "./rechnungen/InvoiceDialog";

const VIEWS = [["months", "Monate"], ["list", "Alle Rechnungen"], ["billing", "Abrechnen"], ["export", "Export Steuerberater"], ["settings", "Rechnungseinstellungen"]];

export default function RechnungenTab({ adminToken: token }) {
  const [view, setView] = useState("months");
  const [filters, setFilters] = useState({ q: "", year: "", month: "", basis: "invoice", status: "" });
  const [openId, setOpenId] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [years, setYears] = useState([]);
  const [meta, setMeta] = useState(null);
  const loadMeta = useCallback(() => apiCall(token, "/rechnungen/admin/settings").then(setMeta).catch(() => {}), [token]);
  useEffect(() => { loadMeta(); }, [loadMeta]);
  const onYears = useCallback((y) => setYears(y), []);

  return (
    <div data-testid="rechnungen-tab">
      {meta?.missing?.length > 0 && (
        <button type="button" onClick={() => setView("settings")} className="w-full text-left flex gap-2 items-center border border-red-500/40 bg-red-500/10 text-red-200 p-3 mb-4 text-sm" data-testid="rechnungen-missing-banner">
          <AlertTriangle className="w-4 h-4" />Fehlende Pflichtangaben für Rechnungen: {meta.missing.join(", ")} – jetzt ergänzen
        </button>
      )}
      <div className="flex flex-wrap border border-white/10 mb-5 w-fit max-w-full" data-testid="rechnungen-views">
        {VIEWS.map(([id, label]) => (
          <button key={id} type="button" onClick={() => setView(id)} className={`px-3 py-2 text-sm whitespace-nowrap transition-colors ${view === id ? "bg-[#c1ff72] text-black font-semibold" : "text-white hover:bg-white/5"}`} data-testid={`rechnungen-view-${id}`}>{label}</button>
        ))}
      </div>
      {view === "months" && <MonthOverview token={token} onYears={onYears} onPickMonth={(y, m, basis) => { setFilters({ ...filters, year: String(y), month: String(m), basis }); setView("list"); }} />}
      {view === "list" && <InvoiceList token={token} filters={filters} setFilters={setFilters} onOpen={setOpenId} reloadKey={reloadKey} years={years} />}
      {view === "billing" && <UninvoicedPanel token={token} onOpen={setOpenId} reloadKey={reloadKey} onChanged={() => setReloadKey((k) => k + 1)} />}
      {view === "export" && <ExportPanel token={token} years={years} datevMissing={meta?.datev_missing} />}
      {view === "settings" && <InvoiceSettings token={token} onSaved={loadMeta} />}
      {openId && <InvoiceDialog token={token} invoiceId={openId} onClose={() => setOpenId(null)} onChanged={() => setReloadKey((k) => k + 1)} onOpen={setOpenId} />}
    </div>
  );
}
